<template>
  <el-dialog
    :title="$t('buildingBrowseManage.delete.title')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div class="delete-warning">
      <i class="el-icon-warning"></i>
      {{ $t('buildingBrowseManage.delete.confirmMessage', { name: form.buildingName || form.id }) }}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteBuildingBrowse } from '@/api/oa/buildingBrowseManageApi'

export default {
  name: 'DeleteBuildingBrowse',
  data() {
    return {
      dialogVisible: false,
      form: {}
    }
  },
  methods: {
    async confirmDelete() {
      try {
        await deleteBuildingBrowse({ id: this.form.id })
        this.$message.success(this.$t('common.deleteSuccess'))
        this.handleClose()
        this.$emit('success')
      } catch (error) {
        console.error('删除房产浏览记录失败:', error)
        this.$message.error(this.$t('common.deleteFailed'))
      }
    },
    open(data) {
      this.dialogVisible = true
      this.form = { ...data }
    },
    handleClose() {
      this.dialogVisible = false
      this.form = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.delete-warning {
  color: #e6a23c;
  padding: 10px 0;
  text-align: center;
  i {
    font-size: 24px;
    margin-right: 10px;
    vertical-align: middle;
  }
}
</style>